import React from "react";
import { Avatar } from "@commonsku/design-system";
import { getImageSrcByImgPaths } from "../../../utils";
import { TaskNote } from "../../../redux/myTasks";

export interface TaskAssigneeAvatarProps {
  note: TaskNote;
}

/** The reminder's assignee's photo; falls back to initials (via Avatar's own `name` fallback) when there isn't one. */
const TaskAssigneeAvatar = ({ note }: TaskAssigneeAvatarProps) => {
  const smallImage = note.reminder_user_image_paths?.small;
  const hasImage = typeof smallImage === "string" && smallImage !== "";

  return (
    <Avatar
      name={note.reminder_user_full_name}
      src={hasImage ? getImageSrcByImgPaths(note.reminder_user_image_paths) : undefined}
      size="2xs"
      shape="rounded"
      flexShrink="0"
      marginTop="1"
    />
  );
};

export default TaskAssigneeAvatar;
